import React from 'react'
import * as url from '_routes/url-names'
import AuthRoute from '_routes/authenticated-route'

const AdminCompanies = React.lazy(() => import('_containers/admin/companies'))
const AdminNewCompany = React.lazy(() => import('_containers/admin/new-company'))
const AdminGroups = React.lazy(() => import('_containers/admin/groups'))
const AdminNewGroup = React.lazy(() => import('_containers/admin/new-group'))
const AdminTemplates = React.lazy(() => import('_containers/admin/templates'))
const AdminPermission = React.lazy(() => import('_containers/admin/permission'))
const AdminSite = React.lazy(() => import('_containers/admin/site-admin'))

export default [
  {
    path: url.COMPANY + url.ADMIN + url.ADMIN_COMPANIES,
    element: <AuthRoute component={AdminCompanies} />
  },
  {
    path: url.COMPANY + url.ADMIN + url.ADMIN_NEW_COMPANY,
    element: <AuthRoute component={AdminNewCompany} />
  },
  {
    path: url.COMPANY + url.ADMIN + url.ADMIN_GROUPS,
    element: <AuthRoute component={AdminGroups} />
  },
  {
    path: url.COMPANY + url.ADMIN + url.ADMIN_NEW_GROUP,
    element: <AuthRoute component={AdminNewGroup} />
  },
  {
    path: url.COMPANY + url.ADMIN + url.ADMIN_TEMPLATES,
    element: <AuthRoute component={AdminTemplates} />
  },
  {
    path: url.COMPANY + url.ADMIN + url.ADMIN_PERMISSION,
    element: <AuthRoute component={AdminPermission} />
  },
  {
    path: url.COMPANY + url.ADMIN + url.ADMIN_SITE,
    element: <AuthRoute component={AdminSite} />
  }
]
